import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { UserDto } from '@system-shared/classes.dto';


@Injectable({
  providedIn: 'root'
})
export class AdminApiService {
  private adminUrl = environment.apiUrl + 'admin'

  constructor (private http: HttpClient) {};

  postUser(params: any){
    return this.http.post(environment.apiUrl + 'users', params, { withCredentials: true });
  }

  getUser(userId: number){
    return this.http.get<UserDto>(environment.apiUrl + `users/id/${userId}`, { withCredentials: true });
  }

  getUserByEmail(email: string){
    return this.http.get<UserDto>(environment.apiUrl + `users/email/${email}`, { withCredentials: true });
  }

  updateUser(params: UserDto){
    return this.http.put(environment.apiUrl + `users`, params, { withCredentials: true });
  }

  deleteUser(userId: number){
    return this.http.delete(this.adminUrl + `/users/${userId}`);
  }

  getUsers(regionCode, forestId) {
    let params = new HttpParams();

    if (regionCode) {
      params = params.set('region', regionCode);
    }

    if (forestId) {
      params = params.set('forestId', forestId);
    }

    return this.http.get(environment.apiUrl + `users`, { withCredentials: true, params });
  }

  getPermits(regionCode, forestId, startDate, endDate){
    let params = new HttpParams();

    if (regionCode) {
      params = params.set('region', regionCode);
    }

    if (forestId) {
      params = params.set('forestId', forestId);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get(environment.apiUrl + `permits/admin`, { withCredentials: true, params });
  }

  getPermitById(permitId: string) {
    return this.http.get(environment.apiUrl + `permits/admin/${permitId}`, { withCredentials: true });
  }

  getForests(){
    return this.http.get(this.adminUrl + '/forests', { withCredentials: true });
  }

  getRoles(){
    return this.http.get(this.adminUrl + '/roles', { withCredentials: true });
  }

  emailPDFbyId(id: string, data) {
    return this.http.post(environment.apiUrl + `permits/email-by-id-admin/${id}`, data, { withCredentials: true });
  }
}
